const Main = () => import('../../pages/main')
const FlowInfo = () => import('../../pages/BaiduStas/index')
export default {
	path: '/flowInfo',
	component: Main,
	meta: {
		sideNav: true
	},
	children: [
		{
			name: 'flowInfo',
			path: 'index',
			component: FlowInfo,
			meta: {
				requiresAuth: true,
				hidden: false,
				title: '流量统计',
				icon: 'icon-nav icon-nav-flow'
			}
		}
	]
}
